const API_BASE = import.meta.env.VITE_API_BASE || "/api";

async function request<T>(path: string, options?: RequestInit): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    credentials: "include",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

  const json = await res.json();
  if (!res.ok || !json.ok) {
    throw new Error(json.error || `Request failed: ${res.status}`);
  }
  return json.data;
}

export function getFeed(sort: string, limit = 20, offset = 0) {
  return request<any[]>(`/feed?sort=${sort}&limit=${limit}&offset=${offset}`);
}

export function getStartup(slug: string) {
  return request<any>(`/startups/${slug}`);
}

export function getStartupHistory(slug: string) {
  return request<any[]>(`/startups/${slug}/history`);
}

export function searchStartups(q: string) {
  return request<any[]>(`/search?q=${encodeURIComponent(q)}`);
}

export function submitVote(data: {
  startup_id: string;
  vibe: number;
  horizon_bucket?: number | null;
  reason_tag?: string | null;
  turnstile_token: string;
}) {
  return request<any>("/vote", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export function submitStartup(data: {
  url: string;
  turnstile_token: string;
}) {
  return request<any>("/startups/submit", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export function submitReport(data: {
  startup_id: string;
  reason_code: string;
  details?: string;
  turnstile_token: string;
}) {
  return request<any>("/report", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export function getVcFeed(sort: string, limit = 20, offset = 0) {
  return request<any[]>(`/vcs/feed?sort=${sort}&limit=${limit}&offset=${offset}`);
}

export function getVc(slug: string) {
  return request<any>(`/vcs/${slug}`);
}

export function submitVcVote(data: {
  vc_id: string;
  vibe: number;
  horizon_bucket?: number | null;
  reason_tag?: string | null;
  turnstile_token: string;
}) {
  return request<any>("/vc-vote", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export function searchVcs(q: string) {
  return request<any[]>(`/vcs/search?q=${encodeURIComponent(q)}`);
}
